import { useSelector } from 'react-redux';
import { profileTypes } from '../config/constants/userConstants';

/**
 * Determines whether the current user is allowed to edit final customers.
 *
 * MASTER, ADMIN and SUPERVISOR profiles can always edit. OPERATOR, TECHNICIAN
 * and INTERESTED profiles depend on the `canEditFinalCustomers` flag configured
 * on their profile.
 */
export const useCanEditFinalCustomer = () => {
  const profileData = useSelector((state) => state.auth?.currentUser?.profile);

  // Public contexts without a session (e.g. self-scheduling) have no profile;
  // do not restrict final customer management there.
  if (!profileData) return true;

  return (
    ![profileTypes.OPERATOR.id, profileTypes.TECHNICIAN.id, profileTypes.INTERESTED.id].includes(
      profileData.idProfile,
    ) || profileData.canEditFinalCustomers
  );
};
